import { BrowserModule } from '@angular/platform-browser';
import { FormsModule } from '@angular/forms';
import { HttpModule } from '@angular/http';
import { Component, NgModule } from '@angular/core';
import { AppComponent } from './app.component';
import { RouterModule, Routes, ActivatedRoute } from '@angular/router';
//
import { HomeComponent } from './home/home.component';
import { LoginComponent } from './login/login.component';
import { LogoutComponent } from './logout/logout.component';
import { SignUpComponent } from './signUp/sign-up.component';
import { ForgotComponent } from './forgot/forgot.component';
import { HeaderComponent } from './header/header.component';
import { FooterComponent } from './footer/footer.component';
import { ContactComponent } from './contact/contact.component';
import { RedirectComponent } from './admin/redirect/redirect.component';
import { PublishComponent } from './publish/publish.component';
import { ErrorComponent } from './error/error.component';
//
import { AutoComponent } from './admin/auto/auto.component';
import { SearchComponent } from './search/search.component';
import { SiloqComponent } from './admin/siloq/siloq.component';
import { TelComponent } from './admin/tel/tel.component';
import { AdminModule }  from './admin/admin.module'; 
//
import {AutoService} from './services/auto.service';
import {SearchService} from './services/search.service';
import {CookieService} from 'ng2-cookies';
import {UserService} from './services/user.service';
import {Login} from './services/user.service';
import {Contact} from './services/user.service';
//
import { TagService } from './services/tag-service.service';
import { TopicService } from './services/topic.service';
 

const appRoutes: Routes = [
    { path: '', component: HomeComponent},
    { path: 'search', component: SearchComponent},
    { path: 'login', component: LoginComponent},
    { path: 'logout', component: LogoutComponent},
    { path: 'signup', component: SignUpComponent},
    { path: 'forgot', component: ForgotComponent},
    { path: 'contact', component: ContactComponent},
    { path: 'publish', component: PublishComponent},
    { path: 'admin/redirect', component: RedirectComponent},
    { path: '**', component: ErrorComponent }
];

@NgModule({
	declarations: [
		AppComponent,
		HomeComponent,
		HeaderComponent,
    LoginComponent,
    LogoutComponent,
    SignUpComponent,
    ForgotComponent,
    FooterComponent,
    ContactComponent,
    PublishComponent,
    RedirectComponent,
    ErrorComponent,
    AutoComponent,
    SearchComponent
	],
	imports: [
		BrowserModule,
		FormsModule,
		HttpModule,
		RouterModule.forRoot(appRoutes),
		AdminModule
	],
	exports: [
		RouterModule,
	],
	providers: [
    CookieService,
    UserService,
   Login,
    Contact,
    TagService,
    TopicService,
    AutoService,
    SearchService
	],
	bootstrap: [
		AppComponent
	]
})

export class AppModule { }



// WEBPACK FOOTER //
// ./src/app/app.module.ts